import { Injectable } from '@angular/core'

@Injectable({
	providedIn: 'root'
})
export class HistoryTrackerService {
	private history: string[] = [];

	public AddUrlHistory(url: string) {
		this.history.push(url);
	}

	public RemoveUrlHistory(): string | undefined {
		return this.history[this.history.length - 1];
	}
}